import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  errorMessage: null,
  successMessage: null,
  isAuthenticated: false,
  redirectToSecureLogin: false,
  redirectToLogin: false,
  token: null,
  distributorId: null,
  customerId: null,
  customerProfile: null,
  defaultDistributorIdSub: null,
  defaultCustomerIdSub: null,
  role: null,
  distributorIdSub: null,
  customerIdSub: null,
  hasAjax: false,
  hasFakeSetting: false,
  tfaToken: null,
});

const { Types, Creators } = createActions({
  setHasAjax: ['hasAjax'],
  setHasFakeSetting: ['hasFakeSetting'],

  loginRequest: ['username', 'password'],
  loginRequestSuccess: [
    'token',
    'distributorId',
    'customerId',
    'defaultCustomerIdSub',
    'defaultDistributorIdSub',
    'customerProfile',
    'role',
    'redirectToSecureLogin',
    'isAuthenticated',
    'distributorIdSub',
    'customerIdSub',
  ],
  loginRequestSuccessRedirectToTfa: [
    'tfaToken'
  ],
  loginRequestFailure: ['errorMessage'],

  twoFactorAuthenticateRequest: ['params'],
  twoFactorAuthenticateRequestSuccess: ['successMessage'],
  twoFactorAuthenticateRequestFailure: ['errorMessage'],

  selectDistributor: ['distributorId', 'distributorIdSub'],
  selectCustomer: ['customerId', 'customerIdSub'],

  logout: null,

  sendResetPasswordEmailRequest: ['username', 'url'],
  sendResetPasswordEmailRequestSuccess: ['successMessage'],
  sendResetPasswordEmailRequestFailure: ['errorMessage'],

  resetPasswordRequest: ['params'],
  resetPasswordRequestSuccess: ['successMessage'],
  resetPasswordRequestFailure: ['errorMessage'],

  clearMessages: null,
  removeTfaRedirect: null,
});

export const setHasAjax = (state, { hasAjax }) => state.merge({ hasAjax });
export const setHasFakeSetting = (state, { hasFakeSetting }) => state.merge({ hasFakeSetting });

export const loginRequest = (state, { username, password }) =>
  state.merge({ isLoading: true, errorMessage: null, redirectToLogin: false, redirectToSecureLogin: false });
export const loginRequestSuccess = (
  state,
  {
    token,
    distributorId,
    customerId,
    defaultCustomerIdSub,
    defaultDistributorIdSub,
    customerProfile,
    role,
    redirectToSecureLogin,
    isAuthenticated,
    distributorIdSub,
    customerIdSub,
  }
) =>
  state.merge({
    isLoading: false,
    token,
    distributorId,
    customerId,
    defaultCustomerIdSub,
    defaultDistributorIdSub,
    customerProfile,
    role,
    redirectToSecureLogin,
    isAuthenticated,
    distributorIdSub,
    customerIdSub,
  });
export const loginRequestSuccessRedirectToTfa = (state, { tfaToken }) => state.merge({ isLoading: false, tfaToken, redirectToSecureLogin: true })
export const loginRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const twoFactorAuthenticateRequest = (state) =>
  state.merge({
    isLoading: true,
    redirectToSecureLogin: false,
    redirectToLogin: false,
    errorMessage: null,
    successMessage: null,
  });
export const twoFactorAuthenticateRequestSuccess = (state, { successMessage }) =>
  state.merge({ isLoading: false, successMessage, isAuthenticated: true });
export const twoFactorAuthenticateRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, redirectToLogin: true, errorMessage });

export const selectDistributor = (state, { distributorId, distributorIdSub }) =>
  state.merge({ distributorId, distributorIdSub });
export const selectCustomer = (state, { customerId, customerIdSub }) => state.merge({ customerId, customerIdSub });

export const logout = (state) => state.merge({ isAuthenticated: false, token: null });

export const sendResetPasswordEmailRequest = (state, { username, url }) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const sendResetPasswordEmailRequestSuccess = (state, { successMessage }) =>
  state.merge({ isLoading: false, successMessage });
export const sendResetPasswordEmailRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const resetPasswordRequest = (state, { params }) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const resetPasswordRequestSuccess = (state, { successMessage }) =>
  state.merge({ isLoading: false, successMessage });
export const resetPasswordRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const clearMessages = (state) => state.merge({ isLoading: false, errorMessage: null, successMessage: null });

export const removeTfaRedirect = (state) => state.merge({redirectToSecureLogin: false})

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_HAS_AJAX]: setHasAjax,
  [Types.SET_HAS_FAKE_SETTING]: setHasFakeSetting,

  [Types.LOGIN_REQUEST]: loginRequest,
  [Types.LOGIN_REQUEST_SUCCESS]: loginRequestSuccess,
  [Types.LOGIN_REQUEST_SUCCESS_REDIRECT_TO_TFA]: loginRequestSuccessRedirectToTfa,
  [Types.LOGIN_REQUEST_FAILURE]: loginRequestFailure,

  [Types.TWO_FACTOR_AUTHENTICATE_REQUEST]: twoFactorAuthenticateRequest,
  [Types.TWO_FACTOR_AUTHENTICATE_REQUEST_SUCCESS]: twoFactorAuthenticateRequestSuccess,
  [Types.TWO_FACTOR_AUTHENTICATE_REQUEST_FAILURE]: twoFactorAuthenticateRequestFailure,

  [Types.SELECT_DISTRIBUTOR]: selectDistributor,
  [Types.SELECT_CUSTOMER]: selectCustomer,

  [Types.LOGOUT]: logout,

  [Types.SEND_RESET_PASSWORD_EMAIL_REQUEST]: sendResetPasswordEmailRequest,
  [Types.SEND_RESET_PASSWORD_EMAIL_REQUEST_SUCCESS]: sendResetPasswordEmailRequestSuccess,
  [Types.SEND_RESET_PASSWORD_EMAIL_REQUEST_FAILURE]: sendResetPasswordEmailRequestFailure,

  [Types.RESET_PASSWORD_REQUEST]: resetPasswordRequest,
  [Types.RESET_PASSWORD_REQUEST_SUCCESS]: resetPasswordRequestSuccess,
  [Types.RESET_PASSWORD_REQUEST_FAILURE]: resetPasswordRequestFailure,

  [Types.CLEAR_MESSAGES]: clearMessages,
  [Types.REMOVE_TFA_REDIRECT]: removeTfaRedirect
});

export const AuthTypes = Types;
export default Creators;
